
import React, { Component } from "react";
import { Row, Column } from "react-foundation";
// slider
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';
import Loading from "../../../components/Loading";
import utils from "utils";

export default class SelectSize extends Component {


    componentDidUpdate() {
        const { loading, range, DoorSize } = this.props;
        const hasValue = DoorSize.Width.input.value !== 0;
        const initialValue = hasValue ? DoorSize.Width.input.value : range.MinWidth; 
        if(!loading && !DoorSize.Width.input.value){
            DoorSize.Width.input.onChange(initialValue);
        }
    }

    getConvertedRange = (unit) => {
        const { range } = this.props;
        return {
            MinWidth: Math.round(utils.convertWindowSize(range.MinWidth, "mm", unit)),
            MaxWidth: Math.round(utils.convertWindowSize(range.MaxWidth, "mm", unit)),
        };
    }

    getMarks = (convertedRange) => {
        let marks = {};
        Object.keys(convertedRange).forEach((key) => {
            const val = convertedRange[key];
            marks[val] = {
                style: {
                    color: 'grey'
                },
                label: <strong>{val}</strong>,
            }
        });
        return marks;
    }

    getScale = (convertedRange) => {
        let windowWidth = window.outerWidth;
        const componentWidth = windowWidth >= 767 ? 355 : 255;
        return componentWidth / convertedRange.MaxWidth;
    }

    handleChange = (value) => {
        const { range, DoorSize } = this.props;
        const unit = DoorSize.Unit.input.value;
        const minWidth = utils.convertWindowSize(range.MinWidth, "mm", unit);
        if(value >= minWidth){
            DoorSize.Width.input.onChange(value);
        }
    }
    
    getTooltip = (props) => {
        const { value, dragging, index, ...restProps } = props;
        const { Handle }  = Slider;
        return (
          <Tooltip
            prefixCls="slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
          >
          <Handle value={value} {...restProps} />
          </Tooltip>
        );
    }

    toggleUnit = (newUnit, doorWidth) => {
        const { DoorSize } = this.props;
        const newWidth = utils.convertWindowSize(doorWidth, DoorSize.Unit.input.value, newUnit);
        DoorSize.Width.input.onChange(newWidth);
        DoorSize.Unit.input.onChange(newUnit);
    }

    render() {
        let { loading, DoorSize } = this.props;
        const unit = DoorSize.Unit.input.value;
        const convertedRange = this.getConvertedRange(unit);
        const doorWidth = DoorSize.Width.input.value;
        const scale = this.getScale(convertedRange);

        if(loading){
            return <Loading />;
        }

        return (
        <Row>
            <Column
                large={12}
                className="size-control"
            >
                <Row className="size-image">
                    <div>
                        <h5 className="door-size-value">{Math.round(doorWidth)}{unit}</h5>
                    </div>
                    <div className="door-frame" style={{ width: `${convertedRange.MaxWidth * scale}px`}}>
                        <div className="door-size" style={{ width: `${doorWidth * scale}px`}}>
                        </div>
                        <Slider 
                        defaultValue={convertedRange.MinWidth}
                        handle={this.getTooltip}
                        marks={this.getMarks(convertedRange)}
                        min={0}
                        max={convertedRange.MaxWidth}
                        onChange={this.handleChange}
                        step={(unit === "mm" ? 100 : 4)}
                        value={doorWidth}
                        />
                    </div>  

                </Row>
            </Column>
            <Column small={12} className="unit-selector">
            <span
                    onClick={() =>
                        this.toggleUnit("mm", doorWidth)
                    }
                    className={(unit === "mm" ? "selected" : "")}
                >
                    mm
                </span>
                <span
                    onClick={() =>
                        this.toggleUnit("inch", doorWidth)
                    }
                    className={(unit === "inch" ? "selected" : "")}
                >
                    inch
                </span>
            </Column>
            </Row>);
    }
}


// WEBPACK FOOTER //
// ./src/containers/DoorForm/uPVC/SelectSize.js